import { SipRecommendationActionType } from '../../api/common.types'
import type { SipPlanRecommendationContainerInput } from '../open/planRecommendationOpen'
import { useSipPlanRecommendation } from '../useSipPlanRecommendation'
import { SipDecreasePlanRecommendationSheet } from './SipDecreasePlanRecommendationSheet'

export function SipDecreasePlanRecommendationContainer(input: SipPlanRecommendationContainerInput) {
  const { onDismiss, isin, totalIdealSipAmount, recommendation, manageSipCta } = input
  const { planDetails, isLoading, isFetchFailed, onRetry } = useSipPlanRecommendation(
    isin,
    SipRecommendationActionType.DECREASE,
    totalIdealSipAmount,
    true
  )

  return (
    <SipDecreasePlanRecommendationSheet
      onDismiss={onDismiss}
      planDetails={planDetails}
      isLoading={isLoading}
      isFetchFailed={isFetchFailed}
      onRetry={onRetry}
      recommendation={recommendation}
      manageSipCta={manageSipCta}
    />
  )
}
